<template>

    <v-row no-gutters>
      <v-col cols="12" md="3" no-gutters>
         <v-card width="370" height="640" tile>
        <v-toolbar flat>
          <v-toolbar-title>GeoAd API Documentation</v-toolbar-title>
        </v-toolbar>
        <v-list rounded class="overflow-y-auto" max-height="560" width="370">
          <v-list-item-group v-model="activeItem" color="primary">
            <v-list-item @click="currentTabComponent = 'Introduction'">
              <v-list-item-content>
                <v-list-item-title>Introduction</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="currentTabComponent = 'BuildingOurAPI'">
              <v-list-item-content>
                <v-list-item-title>Building Applications with our API</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group no-action>
              <template v-slot:activator>
                <v-list-item-content @click="currentTabComponent = 'SupportedFunction'">
                  <v-list-item-title>SUPPORTED API FUNCTIONS</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(functionAPI, j) in functionAPIs"
                :key="j"
                link
                @click="currentTabComponent = functionAPI.link"
              >
                <v-list-item-title v-text="functionAPI.text"></v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-item @click="currentTabComponent = 'Errors'">
              <v-list-item-content>
                <v-list-item-title>Error Messages</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="currentTabComponent = 'Resources'">
              <v-list-item-content>
                <v-list-item-title>Useful Resources</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
      </v-col >
      <v-col cols="12" md="9" no-gutters>
        <v-card width="100%" height="100%">
        <component v-bind:is="currentTabComponent"></component>
      </v-card>
      </v-col>
    </v-row>
   
</template>

<script>
import Navigation from "@/components/header/Navigation";
import {
  AddressAPI,
  AddressAPIID,
  Autocomplete,
  BuildingOurAPI,
  ByFieldAPI,
  Errors,
  Introduction,
  Locality,
  Login,
  Postcodes,
  Resources,
  W3W,
  APIVersion,
  SupportedFunction
} from "@/components/documents";
export default {
  data: () => ({
    currentTabComponent: "Introduction",
    functionAPIs: [
      { text: "LOGIN API", link: "Login" },
      { text: "POSTCODES API", link: "Postcodes" },
      { text: "ADDRESSES API", link: "AddressAPI" },
      { text: "BYFIELD API", link: "ByFieldAPI" },
      { text: "ADDRESSID API", link: "AddressAPIID" },
      { text: "AUTOCOMPLETE API", link: "Autocomplete" },
      { text: "LOCALITY API", link: "Locality" },
      { text: "POSTCODE/W3W  API", link: "W3W" },
      { text: "API Version  API", link: "APIVersion" }
    ]
  }),
  components: {
    Navigation,
    Introduction,
    AddressAPI,
    AddressAPIID,
    Autocomplete,
    BuildingOurAPI,
    ByFieldAPI,
    Errors,
    Locality,
    Login,
    Postcodes,
    Resources,
    W3W,
    APIVersion,
    SupportedFunction
  },
  props: {
    activeItem: {
      default: 0,
      type: Number
    }
  }
};
</script>
<style scoped>
.toolbar {
  text-align: center;
  justify-content: space-between;
  height: 80px;
  padding-top: 30px;
}

.optionMain {
  overflow-y: scroll;
  max-height: 85%;
  position: fixed;
  z-index: 111;
  cursor: pointer;
}

.mainCard {
  padding: 15px;
  margin-left: 340px;
}
</style>